import IconDropzone from './IconDropzone.js'
export { IconDropzone }



// WEBPACK FOOTER //
// ./src/components/Dropzone/index.js